//----------------------
// <auto-generated>
//     Generated using the NSwag toolchain v13.18.0.0 (NJsonSchema v10.8.0.0 (Newtonsoft.Json v13.0.0.0)) (http://NSwag.org)
// </auto-generated>
//----------------------

/* tslint:disable */
/* eslint-disable */
// ReSharper disable InconsistentNaming



export interface AttorneyInformation {
  name?: string | undefined;
  barNumber?: string | undefined;
  status?: string | undefined;
  officeNumber?: string | undefined;
  email?: string | undefined;
  alternateContactMethod?: string | undefined;
  address1?: string | undefined;
  address2?: string | undefined;
  city?: string | undefined;
  state?: string | undefined;
  zipCode?: string | undefined;
}

export interface ChecklistItem {
  taskId?: number | undefined;
  isChecked?: boolean;
  isAssigned?: boolean;
  taskName?: string | undefined;
}

export interface ComboBoxItem {
  itemId?: any | undefined;
  itemText?: string | undefined;
  itemType?: string | undefined;
  code?: string | undefined;
  totalCount?: number | undefined;
}

export interface CommentDetail {
  id?: number;
  value?: string | undefined;
  firstName?: string | undefined;
  lastName?: string | undefined;
  createdAt?: Date | undefined;
}

export interface ContactInsertRequest {
  personTypeId?: number | undefined;
  genderId?: number | undefined;
  statusId?: number | undefined;
  userId?: number | undefined;
  regionId?: number | undefined;
  fullName?: string | undefined;
  firstName?: string | undefined;
  lastName?: string | undefined;
  barNumber?: string | undefined;
  lawFirm?: string | undefined;
  address1?: string | undefined;
  address2?: string | undefined;
  city?: string | undefined;
  state?: string | undefined;
  zipCode?: string | undefined;
  email?: string | undefined;
  phoneNumber?: string | undefined;
  birthDate?: Date | undefined;
  admitDate?: Date | undefined;
  isJudge?: boolean | undefined;
  universeEID?: string | undefined;
  attorneysPerFirm?: number | undefined;
  malpracticeClaims?: number | undefined;
  suspenseClaims?: number | undefined;
  altContactMethod?: string | undefined;
  isAltContactPref?: boolean | undefined;
}

export interface ContactResponse {
  contactId?: number;
  personType?: LookUpEntity;
  gender?: string | undefined;
  status?: string | undefined;
  region?: LookUpEntity;
  officeClosureCode?: string | undefined;
  officeClosureTaskId?: number | undefined;
  optedInItems?: ComboBoxItem[] | undefined;
  fullName?: string | undefined;
  firstName?: string | undefined;
  lastName?: string | undefined;
  barNumber?: string | undefined;
  lawFirm?: string | undefined;
  address1?: string | undefined;
  address2?: string | undefined;
  city?: string | undefined;
  state?: string | undefined;
  zipCode?: string | undefined;
  email?: string | undefined;
  phoneNumber?: string | undefined;
  birthDate?: Date | undefined;
  admitDate?: Date | undefined;
  isJudge?: boolean | undefined;
  universeEID?: string | undefined;
  attorneysPerFirm?: number | undefined;
  malpracticeClaims?: number | undefined;
  suspenseClaims?: number | undefined;
  altContactMethod?: string | undefined;
  isAltContactPref?: boolean | undefined;
}

export interface ContactUpdateRequest {
  contactId?: number;
  officeClosureId?: number | undefined;
  optedInItems?: ComboBoxItem[] | undefined;
  personTypeId?: number | undefined;
  genderId?: number | undefined;
  statusId?: number | undefined;
  userId?: number | undefined;
  regionId?: number | undefined;
  fullName?: string | undefined;
  firstName?: string | undefined;
  lastName?: string | undefined;
  barNumber?: string | undefined;
  lawFirm?: string | undefined;
  address1?: string | undefined;
  address2?: string | undefined;
  city?: string | undefined;
  state?: string | undefined;
  zipCode?: string | undefined;
  email?: string | undefined;
  phoneNumber?: string | undefined;
  birthDate?: Date | undefined;
  admitDate?: Date | undefined;
  isJudge?: boolean | undefined;
  universeEID?: string | undefined;
  attorneysPerFirm?: number | undefined;
  malpracticeClaims?: number | undefined;
  suspenseClaims?: number | undefined;
  altContactMethod?: string | undefined;
  isAltContactPref?: boolean | undefined;
}

export interface EmailOrAddress {
  firstName?: string | undefined;
  middleName?: string | undefined;
  lastName?: string | undefined;
  suffix?: string | undefined;
  address1?: string | undefined;
  address2?: string | undefined;
  address3?: string | undefined;
  city?: string | undefined;
  state?: string | undefined;
  zipCode?: string | undefined;
  phone?: string | undefined;
  fax?: string | undefined;
  barNumber?: string | undefined;
  memberType?: string | undefined;
  prefix?: string | undefined;
}

export interface EmailOrAddressRequest {
  listType?: ListType;
  yearAdmittedFrom?: string | undefined;
  yearAdmittedThru?: string | undefined;
  plfType?: string[] | undefined;
  optedIn?: string[] | undefined;
  status?: string[] | undefined;
  state?: string[] | undefined;
  county?: string[] | undefined;
  gender?: string[] | undefined;
  outputTo?: OutputType;
}

export interface EmailOrAddressResponse {
  state?: string | undefined;
  listType?: string | undefined;
  items?: EmailOrAddress[] | undefined;
}

export interface RegionLookupResponse {
  status?: string | undefined;
  message?: string | undefined;
  data?: RegionInformation | undefined;
}

export interface RegionInformation {
  code: string;
  description: string;
}

export interface FilesInformation {
  activeFileComment?: string | undefined;
  closedFileStoredWith?: string | undefined;
  closedFilePhoneNumber?: string | undefined;
  closedFileEmail?: string | undefined;
  closedFileAddress1?: string | undefined;
  closedFileAddress2?: string | undefined;
  closedFileCity?: string | undefined;
  closedFileState?: string | undefined;
  closedFileZipCode?: string | undefined;
}

export interface ForgotPasswordRequest {
  emailAddress?: string | undefined;
}

export interface InteractionInsertRequest {
  task?: TaskDetail;
  contactId?: number;
  regionId?: number;
  interactionTypeId?: number;
  methodOfContactId?: number;
  areaOfAssistanceId?: number;
  comment?: string | undefined;
  userId?: number;
  interactionDate?: Date;
  cellNumber?: string | undefined;
  notes?: string | undefined;
  otherEmailAddress?: string | undefined;
}

export interface InteractionResponse {
  interactionId?: number;
  contact?: ContactResponse;
  interactionType?: string | undefined;
  methodOfContact?: string | undefined;
  areaOfAssistance?: string | undefined;
  comments?: CommentDetail[] | undefined;
  tasks?: TaskDetail[] | undefined;
  user?: User;
  interactionDate?: Date;
  cellNumber?: string | undefined;
  notes?: string | undefined;
  otherEmailAddress?: string | undefined;
}

export interface InteractionResponsePagedResult {
  pageNumber?: number;
  pageSize?: number;
  totalItems?: number;
  readonly totalPages?: number;
  orderBy?: string | undefined;
  orderDirection?: string | undefined;
  items?: InteractionResponse[] | undefined;
}

export interface InteractionUpdateRequest {
  interactionId?: number;
  updatedBy?: number;
  contactId?: number;
  interactionTypeId?: number;
  methodOfContactId?: number;
  areaOfAssistanceId?: number;
  comment?: string | undefined;
  userId?: number;
  interactionDate?: Date;
  cellNumber?: string | undefined;
  notes?: string | undefined;
  otherEmailAddress?: string | undefined;
}

export interface LawyerAlternativeContact {
  id?: number | undefined;
  name?: string | undefined;
  phoneNumber?: string | undefined;
  email?: string | undefined;
  address1?: string | undefined;
  address2?: string | undefined;
  city?: string | undefined;
  state?: string | undefined;
  zipCode?: string | undefined;
  isFamily?: boolean;
  isColleague?: boolean;
  isStaff?: boolean;
  isFriend?: boolean;
  isAssistingAtty?: boolean;
  isOther?: boolean;
  other?: string | undefined;
}

export enum ListType {
  Address = "Address",
  Email = "Email",
}

export interface LoginRequest {
  userLogin: string;
  password: string;
}

export interface LoginResponse {
  accessToken?: string | undefined;
  refreshToken?: string | undefined;
  currentUser?: User;
}

export interface LookUpEntity {
  name?: string | undefined;
  code?: string | undefined;
  lookUpType?: string | undefined;
  id?: number;
  createdAt?: Date | undefined;
  createdBy?: number | undefined;
  lastModified?: Date | undefined;
  updatedBy?: number | undefined;
  totalItems?: number;
}

export interface OfficeClosureForm {
  isDownloadForm?: boolean;
  contacId?: number;
  taskId?: number;
  userId?: number;
  content?: OfficeClosureFormContent;
}

export interface OfficeClosureFormContent {
  notes?: string | undefined;
  attorneyInformation?: AttorneyInformation;
  plfInformation?: PLFInformation;
  reasonForClosure?: ReasonForClosure;
  filesInformation?: FilesInformation;
  checklist?: ChecklistItem[] | undefined;
  lawyerAlternativeContactList?: LawyerAlternativeContact[] | undefined;
}

export enum OutputType {
  Json = "json",
  File = "file",
}

export interface PLFInformation {
  pmaId?: string | undefined;
  pma?: string | undefined;
  claimsAttorney?: string | undefined;
  oaapCounselor?: string | undefined;
  defensePanelMember?: string | undefined;
  phoneNumber?: string | undefined;
  email?: string | undefined;
}

export interface People {
  id?: number;
  fullName?: string | undefined;
}

export interface ReasonForClosure {
  isDead?: boolean;
  isIncapacity?: boolean;
  isRetirement?: boolean;
  isDiscipline?: boolean;
  isPersonal?: boolean;
  otherReason?: string | undefined;
}

export interface Reports {
  embeddedUrl?: string | undefined;
}

export interface ResetPasswordRequest {
  password?: string | undefined;
  token?: string | undefined;
}

export interface SubTaskDetail {
  parentId?: number | undefined;
  id?: number | undefined;
  name?: string | undefined;
  dueDate?: Date | undefined;
  assignedTo?: User;
  taskStatus?: ComboBoxItem;
  tags?: TagResponse[] | undefined;
  taskDetails?: string | undefined;
  comments?: CommentDetail[] | undefined;
  templateId?: number | undefined;
  contact?: ComboBoxItem;
  createdBy?: number | undefined;
}

export interface SubTaskTemplateDetail {
  parentId?: number | undefined;
  id?: number | undefined;
  name?: string | undefined;
  tags?: TagResponse[] | undefined;
  taskDetails?: string | undefined;
}

export enum TagAssignmentType {
  _0 = 0,
  _1 = 1,
  _2 = 2,
}

export interface TagInsertRequest {
  name?: string | undefined;
  colorCode?: string | undefined;
  comment?: string | undefined;
  assignmentType?: TagAssignmentType;
}

export interface TagResponse {
  id?: number;
  name?: string | undefined;
  colorCode?: string | undefined;
  comment?: string | undefined;
  assignmentType?: TagAssignmentType;
}

export interface TagUpdateRequest {
  id?: number;
  name?: string | undefined;
  colorCode?: string | undefined;
  comment?: string | undefined;
  assignmentType?: TagAssignmentType;
}

export interface TaskComment {
  comment?: string | undefined;
  taskId?: number | undefined;
}

export interface TaskDetail {
  subTasks?: SubTaskDetail[] | undefined;
  id?: number | undefined;
  name?: string | undefined;
  dueDate?: Date | undefined;
  assignedTo?: User;
  taskStatus?: ComboBoxItem;
  tags?: TagResponse[] | undefined;
  taskDetails?: string | undefined;
  comments?: CommentDetail[] | undefined;
  templateId?: number | undefined;
  contact?: ComboBoxItem;
  createdBy?: number | undefined;
}

export interface TaskResponse {
  taskStatus?: TaskStatus;
  tags?: TagResponse[] | undefined;
  totalComments?: number | undefined;
  totalSubTasks?: number | undefined;
  assignedTo?: User;
  people?: People;
  taskId?: number;
  name?: string | undefined;
  assignTo?: number;
  taskDetails?: string | undefined;
  parentId?: number | undefined;
  dueDate?: Date;
  taskStatusId?: number;
  templateId?: number | undefined;
}

export interface TaskResponsePagedResult {
  pageNumber?: number;
  pageSize?: number;
  totalItems?: number;
  readonly totalPages?: number;
  orderBy?: string | undefined;
  orderDirection?: string | undefined;
  items?: TaskResponse[] | undefined;
}

export interface TaskWithOfficeClosureResponse {
  taskId?: number;
  name?: string | undefined;
  taskStatus?: string;
  created?: Date;
}

export interface TaskStatisticsResponse {
  totalTasksDueToday?: number | undefined;
  totalTasksDueWeek?: number | undefined;
  totalTasksPastDue?: number | undefined;
}

export interface TaskStatus {
  taskStatusId?: number;
  name?: string | undefined;
  code?: string | undefined;
  isPastDue?: boolean | undefined;
}

export interface TaskSummaryResponse {
  dueDate?: Date | undefined;
  total?: number | undefined;
}

export interface TaskTemplateDetail {
  subTasks?: SubTaskTemplateDetail[] | undefined;
  id?: number | undefined;
  name?: string | undefined;
  tags?: TagResponse[] | undefined;
  taskDetails?: string | undefined;
}

export interface UIConfig {
  reports?: Reports;
}

export interface User {
  userId?: number;
  userLogin: string;
  userName: string;
  firstName: string;
  lastName: string;
  password: string;
  emailAddress: string;
  isEnable: boolean;
  isLocked: boolean;
  refreshToken?: string | undefined;
  refreshTokenExpiryTime?: Date | undefined;
}

export interface UserPagedResult {
  pageNumber?: number;
  pageSize?: number;
  totalItems?: number;
  readonly totalPages?: number;
  orderBy?: string | undefined;
  orderDirection?: string | undefined;
  items?: User[] | undefined;
}